var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('shop-head',{attrs:{"currentPageName":"aboutUs"}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.aboutInfo[0].url,"alt":""}})]),_c('div',{staticClass:"video"},[_c('video',{attrs:{"controls":"","src":_vm.aboutInfo[1].url,"type":"video/mp4"}})])]),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }